import { TerminologyAttribute } from 'app/mdm/terminology-lib/services/terminology-attribute';
import { DateRange } from '@heda/core-util';

export class CodeSystem {
  public id: string;
  public names: { [key: string]: string };
  public title: { [key: string]: string };
  public behavior: string;
  public url: string;

  public attributes: Array<TerminologyAttribute>;
  public notes: any;

  public concepts: Array<CodeSystemConcept>;
}

export class CodeSystemConcept {
  public code: string;
  public names?: { [key: string]: string };
  public id?: number;
  public attributes?: { [key: string]: any };
  public children?: Array<CodeSystemConcept>;
  public valid?: DateRange;
  public parent?: string;
}
